import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadIndustries = async () => {
  try {
    const response = await Axios.get('industries');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadIndustry = async (action) => {
  try {
    switch (action) {
      case 'new':
        // const response = await Axios.get('setups/product-categories');
        // const responseData = await response.data;
        // return {...responseData, category: {}};
        return {};
        
      default:
        const respnse = await Axios.get('industries/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useIndustriesAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('industries', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('industry_created', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('industries/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('industry_update', data.seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useIndustriesAPI;


